/**
 * Real API implementation for Organization.
 * v3: GET /api/v3/organizations/{id}. web-api: CRUD /api/web-api/organizations/.
 */

import { apiClient } from '../apiClient';

const V3_ORGANIZATIONS_PATH = '/api/v3/organizations';
const WEB_API_ORGANIZATIONS_PATH = '/api/web-api/organizations';

const normalizeOrgResponse = (payload) => payload?.data ?? payload ?? null;

export const getOrganizationById = async (organizationId) => {
  const response = await apiClient.get(
    `${V3_ORGANIZATIONS_PATH}/${organizationId}`,
  );
  return normalizeOrgResponse(response.data);
};

/**
 * Build request body for PATCH: flat form (name, industry, street, city, state, zip_code) → API shape (name?, industry?, address?).
 */
function buildUpdateOrganizationBody(data) {
  const body = {};
  if (data.name !== undefined) body.name = data.name;
  if (data.industry !== undefined) body.industry = data.industry;
  const hasAddress =
    data.street !== undefined ||
    data.city !== undefined ||
    data.state !== undefined ||
    data.zip_code !== undefined;
  if (hasAddress) {
    body.address = {};
    if (data.street !== undefined) body.address.street = data.street;
    if (data.city !== undefined) body.address.city = data.city;
    if (data.state !== undefined) body.address.state = data.state;
    if (data.zip_code !== undefined) body.address.zipCode = data.zip_code;
  }
  return body;
}

export const updateOrganizationV2 = async (id, organization) => {
  const body = buildUpdateOrganizationBody(organization);
  const response = await apiClient.patch(
    `${WEB_API_ORGANIZATIONS_PATH}/${id}/`,
    body,
  );
  return response.data;
};

export const getAllOrganizations = async () => {
  const response = await apiClient.get(`${WEB_API_ORGANIZATIONS_PATH}/`);
  return response.data;
};

export const addOrganization = async (organization) => {
  const response = await apiClient.post(
    `${WEB_API_ORGANIZATIONS_PATH}/`,
    organization,
  );
  return response.data;
};

export const updateOrganization = async (id, organization) => {
  const response = await apiClient.put(
    `${WEB_API_ORGANIZATIONS_PATH}/${id}/`,
    organization,
  );
  return response.data;
};

export const deleteOrganization = async (id) => {
  await apiClient.delete(`${WEB_API_ORGANIZATIONS_PATH}/${id}/`);
};

export const createOrganization = async (data) => {
  const response = await apiClient.post(
    `${WEB_API_ORGANIZATIONS_PATH}/`,
    data,
  );
  return response.data;
};

export const createAdministrator = async (organizationId, adminData) => {
  const response = await apiClient.post(
    `${WEB_API_ORGANIZATIONS_PATH}/${organizationId}/administrator`,
    adminData,
  );
  return response.data;
};
